<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row table-responsive" style="margin: 0 !important">
        <div class="form-group margin-0">
          <div class="search-wrap">
            <div class="search-item">
              <label class="col-sm-2  "> Category </label>
              <div class="col-sm-4">
                <el-select
                  disabled
                  v-model="detailInfo.level"
                  placeholder="Select"
                  clearable
                >
                  <el-option
                    v-for="item in categoryMap"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-item">
              <label class="col-sm-2  "> Entry Number </label>
              <div class="col-sm-4 entry-no-wrap">
                <el-input
                  disabled
                  v-model="entryNumberHead"
                  clearable
                  placeholder="3 Char"
                ></el-input>
                <div class="separator">-</div>
                <el-input
                  disabled
                  v-model="entryNumberBody"
                  clearable
                  placeholder="Month + Day"
                ></el-input>
              </div>
            </div>
            <div class="search-item">
              <label class="col-sm-2  "> Judging Panel </label>
              <div class="col-sm-4">
                <el-input
                  disabled
                  v-model="detailInfo.judginPanel"
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="search-item">
              <label class="col-sm-2  "> Scoring Status </label>
              <div class="col-sm-4">
                <el-input
                  disabled
                  v-model="detailInfo.scoringStatus"
                  clearable
                ></el-input>
              </div>
            </div>
          </div>

          <el-table
            :data="JudgeOverallDetailList"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column type="index" label="S/N" fixed width="60">
            </el-table-column>
            <el-table-column prop="judgeName" label="Judges Name">
            </el-table-column>
            <el-table-column prop="score" label="Score">
              <template slot-scope="scope">
                <div>{{scope.row.score?`${scope.row.score}/100`:''}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="lastUpdateDate" label="Last Update Date">
            </el-table-column>
            <el-table-column
              prop="lastUpdateTime"
              label="Last Update Time"
            ></el-table-column>
            <!-- <el-table-column label="History" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary"
                  >View</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
          <el-col>
            <div class="final-score-wrap">
              <label class="col-sm-2 control-label final-score"> Final Score </label>
              <div class="col-sm-2 entry-no-wrap">
                <el-input
                  disabled
                  v-model="finalScore"
                  clearable
                ></el-input>
              </div>
            </div>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      userInfo: {
        userId: null,
        token: "",
      },
      detailInfo: {
        level:'',
        entryNumber:'',
        scoringStatus:'',
        judginPanel:'',
      },
      groupList: [],
      JudgeOverallDetailList: [],
      finalScore: "",
    };
  },

  created() {
    this.intiPage()
  },
  mounted() {},
  components: {},
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    detailId(){
      return this.$route.query.stemupUploadId
    },
    entryNumberHead(){
      const entryNo=this.detailInfo.entryNumber
      if(entryNo){
        const resList=entryNo.split('-')
        return resList.length?resList[0]:''
      }
      return ''
    },
    entryNumberBody(){
      const entryNo=this.detailInfo.entryNumber
      if(entryNo){
        const resList=entryNo.split('-')
        return resList.length?resList[1]:entryNo
      }
      return ''
    },
    categoryMap() {
      return [
        {key:'1',val:"Junior Primary"},
        {key:'2',val:"Senior Primary"},
        {key:'3',val:"Junior Secondary"},
        {key:'4',val:"Senior Secondary"},
      ]
    },
  },
  methods: {
    async intiPage(){
      this.getUserInfo();
      this.getDetailInfo()
      await this.handleSearchList()
    },
    getUserInfo() {
      this.userInfo = this.getAuthObj();
    },
    getDetailInfo(){
      this.detailInfo=this.$route.query
    },
    async handleSearchList() {
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getHsbcJudgeEntryDetail', {...this.userInfo,stemupUploadId:this.detailId})
      if(status_code=='0') {
        this.JudgeOverallDetailList=result
        this.finalScore=(result&&result.length&&(result[0].finalScore||result[0].finalScore==0)?result[0].finalScore+"/100":'-')
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    }
  },
};
</script>
  
<style lang="scss" scoped>
.search-wrap {
  display: flex;
  flex-direction: column;
  .search-item {
    margin-bottom: 15px;
    display: flex;
    .entry-no-wrap {
      display: flex;
      .separator {
        margin: 0 10px;
        display: flex;
        align-items: center;
      }
    }
    .btn-wrap {
      display: flex;
      justify-self: flex-end;
    }
  }
}
.final-score-wrap {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  .final-score{
    display:flex;
    justify-content: flex-end;
  }
}
 ::v-deep .el-input__inner{
  text-align: center;
}
</style>
